import useAuthStore from "store/auth";

export default function authHeader() {
  const token = useAuthStore.getState().getToken();

  if (token) {
    return {"x-auth-token": token};
  } else {
    return {};
  }
}
